/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { loadRubrics } from '@linc-technologies/linced-common/utils/rubrics';

export default class IndexRoute extends Route {
  queryParams = {
    jurisdiction: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  _hasLoaded = false;

  model(params) {
    let parentModel = this.modelFor('rubrics');
    let jurisdiction = params.jurisdiction || 1;

    this.store.query('reports/rubric-family', { jurisdiction });

    if (this._hasLoaded) {
      // Return cached rubrics immediately, refresh in the background
      let rubrics = this.store.peekAll('reports/rubric');
      loadRubrics(this.store, jurisdiction);
      return Object.assign({}, parentModel, { rubrics });
    }

    this._hasLoaded = true;
    return loadRubrics(this.store, jurisdiction).then((rubrics) => {
      return Object.assign({}, parentModel, { rubrics });
    });
  }
}
